<template>
    <div class="footer">
        TCD Web Design ©2019 by Youquan Yu
    </div>
</template>
<script>
export default {
    
};
</script>
<style scoped>
    .footer {
        position: absolute;
        height: 20px;
        right: 0;
        overflow: hidden;
        background: #fff;
        padding-right: 120px;
    }
</style>
